import { Col, ColProps, Row } from 'antd';
import { omit } from 'lodash';
import React, { FC } from 'react';
import { CardSizes, data, OverviewCardPayload } from '../api';
import { KEIResponsiveCard, ResponsiveCard } from '../style';
import { GridSystemConfig } from './config';

export const CustomisableLeftSectionCards: FC<{
  data?: OverviewCardPayload[];
  extra?: ColProps;
  cardConfig: any;
}> = ({ data: cards = data, extra, cardConfig }) => {
  return (
    <>
      {cards
        .filter((card) => !card.hidden)
        .map((card) => {
          const currentConfigCard = card.cardName
            ? cardConfig[card.cardName]
            : {
                title: <>{card.title}</>,
                content: <>{card.content}</>,
              };
          const spanProps = {
            ...omit(GridSystemConfig[card.type], ['children']),
            ...extra,
          };
          const datacy = `project.overview.${card.cardName}`;

          return (
            <Col
              data-cy={datacy}
              key={card.id}
              xxl={spanProps.xxl}
              xl={spanProps.xl}
              lg={spanProps.lg}
              md={spanProps.md}
              sm={spanProps.sm}
              xs={spanProps.xs}
            >
              {card.type === CardSizes.Grouped ? (
                <Row gutter={[8, 8]}>
                  <CustomisableLeftSectionCards
                    data={card.content}
                    extra={GridSystemConfig[card.type].children}
                    cardConfig={cardConfig}
                  />
                </Row>
              ) : card.type === CardSizes.Medium ? (
                <KEIResponsiveCard>
                  {currentConfigCard?.title}
                </KEIResponsiveCard>
              ) : (
                <ResponsiveCard title={currentConfigCard?.title}>
                  {currentConfigCard?.content}
                </ResponsiveCard>
              )}
            </Col>
          );
        })}
    </>
  );
};
